import React, { useCallback, useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'modules/hooks/appHooks';
import { useTranslation } from 'react-i18next';
import { useSidePopout } from 'modules/layout';
import { SearchSelectors, SearchThunks } from './redux';
import { Search } from '../search';
import { SearchItemCategory } from './components/searchItem/helper';
import { SearchList } from './components/searchList';
import { resetState } from './redux/slice';
import { InstructionText } from './components/instructionText/InstructionText';
import { HeaderSearchWrapper } from './styled';
import { SuggestionItem } from './components/searchList/SearchList';

export const HeaderSearch: React.FC = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { closePopout } = useSidePopout();

  const searchResults = useAppSelector(SearchSelectors.selectSearchResults);
  const totalCount = useAppSelector(SearchSelectors.selectResultsTotalCount);

  const [searchValue, setSearchValue] = useState('');
  const [instructionText, setInstructionText] = useState({
    title: '',
    description: '',
  });

  const mappedSearchResults: SuggestionItem[] = [
    {
      itemsCategory: SearchItemCategory.CONTRACT,
      items: searchResults?.contractsResults?.map(
        (contract) => contract.number,
      ),
    },
    {
      itemsCategory: SearchItemCategory.BILL,
      items: searchResults?.billsResults?.map((bill) => bill.number),
    },
    {
      itemsCategory: SearchItemCategory.OFFER,
      items: searchResults?.offersResults?.map((offer) =>
        offer.number.toString(),
      ),
    },
  ];

  const onSearch = useCallback(
    (search: string) => {
      setSearchValue(search);
      dispatch(SearchThunks.fetchSearchResults({ search }));
    },
    [dispatch],
  );

  useEffect(() => {
    if (totalCount && totalCount > 0) {
      setInstructionText({
        title: t('headerSearch.instructionText.resultsFoundTitle'),
        description: t('headerSearch.instructionText.resultsFoundDescription'),
      });
    } else if (searchResults && searchValue) {
      setInstructionText({
        title: t('headerSearch.instructionText.resultsNotFoundTitle'),
        description: t(
          'headerSearch.instructionText.resultsNotFoundDescription',
        ),
      });
    } else if (!searchResults) {
      setInstructionText({
        title: '',
        description: '',
      });
    }
  }, [t, totalCount, searchValue, searchResults]);

  useEffect(
    () => () => {
      dispatch(resetState());
    },
    [dispatch],
  );

  return (
    <HeaderSearchWrapper>
      <Search handleSearch={onSearch} />
      {totalCount !== undefined && totalCount > 0 && (
        <SearchList data={mappedSearchResults} onClick={closePopout} />
      )}
      <InstructionText
        title={instructionText.title}
        description={instructionText.description}
      />
    </HeaderSearchWrapper>
  );
};
